import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatPrefix,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from '../CommonController/common-api-service';
import { UserManagementApiService } from '../CommonController/userManagement-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';
import { environment } from 'src/environments/environment';
import { MenuRouteMap } from '../shared/variables/menu-route-map';
import { MenuItem } from '../shared/variables/MenuItem';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatIcon,
    MatPrefix,
    MatInput,
    MatError,
    MatSuffix,
  ],
})
export class LoginPageComponent implements OnInit {
  headerProjectName = environment.headerProjectName;
  environment = environment.environment;

  fieldTextType = false;

  isForgotPassword = false;

  userPermissions = [];

  loginForm: FormGroup;

  forgotPasswordForm: FormGroup;

  rawMenu: MenuItem[] = [];
  menuTree: MenuItem[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private fb: FormBuilder,
    public router: Router,
    public snackBar: MatSnackBar,
    public userManagementApiService: UserManagementApiService,
    public commonApiService: CommonApiService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.spinner.hide();
    this.setloginForm();
    this.setForgotPasswordForm();
    this.clearSession();
  }

  toggleForm() {
    this.isForgotPassword = !this.isForgotPassword;
    this.setloginForm();
    this.setForgotPasswordForm();
  }

  setloginForm() {
    this.loginForm = this.fb.group({
      email: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.validEmail,
        ],
      ],
      password: [
        '',
        [Validators.required, SharedValidators.minLengthRequired(6)],
      ],
    });
  }

  setForgotPasswordForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.validEmail,
        ],
      ],
    });
  }

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  getLoginImageClass(): string {
    if (this.headerProjectName === 'LCT-A4G') {
      return 'login-image-section login-image-section-lct';
    } else if (this.headerProjectName === 'Swaraj-Treo') {
      return 'login-image-section login-image-section-swaraj-treo';
    } else if (this.headerProjectName === 'LCT A4G - Tarang') {
      return 'login-image-section login-image-section-lct_tarang';
    } else if (this.headerProjectName === 'Treo') {
      return 'login-image-section login-image-section-treo';
    } else if (this.headerProjectName === 'Swaraj-SD') {
      return 'login-image-section login-image-section-ram100-sd';
    } else if (this.headerProjectName === 'Swaraj-FD') {
      return 'login-image-section login-image-section-ram100-fd';
    }
    return 'login-image-section';
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.onLogin();
    } else {
      SharedValidators.markAllAsTouched(this.loginForm);
    }
  }

  onLogin() {
    this.spinner.show();
    const payLoadData = this.loginForm.value;
    const data = {
      userEmail: payLoadData.email,
      password: payLoadData.password,
    };
    // accountLogin API start
    this.commonApiService.userLogin(data).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          sessionStorage.setItem('loggedInUserId', res.data.id);
          sessionStorage.setItem(
            'loggedInUserHierarchy',
            res.data.loggedInUserHierarchy
          );
          sessionStorage.setItem('id', res.data.id);
          sessionStorage.setItem(
            'token',
            this.commonApiService.encryptData(res.data.token)
          );
          sessionStorage.setItem(
            'userPermissions',
            JSON.stringify(res.data.userPermission)
          );
          sessionStorage.setItem('userRole', res.data.userRole);
          sessionStorage.setItem('loggedInUserEmail', res.data.email);
          sessionStorage.setItem('roleType', res.data.roleType);
          sessionStorage.setItem('leadName', res.data.leadName);
          sessionStorage.setItem('userName', res.data.fullName);
          this.rawMenu = res.data.userPermission;
          // if (res.data.userRole === 'Admin' || res.data.userRole === 'Super Admin') {
          //   this.redirect('device-dashboard-page');
          // } else {
          this.userPermissions = res.data.userPermission;
          if (this.userPermissions.length === 0) {
            this.commonApiService.openSnackbar(
              "User does't have any permissions!"
            );
          } else {
            this.buildMenuTree();
            if (this.menuTree.length > 0) {
              const firstRoot = this.menuTree[0];
              let firstMenuName = '';
              if (firstRoot.children && firstRoot.children.length > 0) {
                firstMenuName = firstRoot.children[0].pageName;
              } else {
                firstMenuName = firstRoot.pageName;
              }
              this.router.navigate([MenuRouteMap[firstMenuName] || '']);
            }
          }
        }
        //this.spinner.hide();
        // }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      }
    );
  }

  buildMenuTree() {
    const menuMap = new Map<number, MenuItem>();
    const roots: MenuItem[] = [];

    // Filter only those with view === true
    const visibleMenus = this.rawMenu.filter((item) => item.view === true);

    // Initialize menuMap and clear children
    visibleMenus.forEach((item) => {
      item.children = [];
      menuMap.set(item.id, item);
    });

    if (visibleMenus.length === 1) {
      this.menuTree = visibleMenus;
      return;
    }
    // Build the tree
    visibleMenus.forEach((item) => {
      if (item.parentMenuId === null) {
        roots.push(item);
      } else {
        const parent = menuMap.get(item.parentMenuId);
        if (parent) {
          parent.children!.push(item);
        }
      }
    });

    // Sort by sequenceId at each level
    const sortMenus = (menus: MenuItem[]) => {
      menus.sort((a, b) => a.sequenceId - b.sequenceId);
      menus.forEach((menu) => {
        if (menu.children) {
          sortMenus(menu.children);
        }
      });
    };
    sortMenus(roots);
    this.menuTree = roots;
  }

  onForgotPassword() {
    if (this.forgotPasswordForm.valid) {
      this.spinner.show();
      const data = this.forgotPasswordForm.get('email').value;
      this.commonApiService.forgotPassword(data).subscribe({
        next: (res) => {
          this.spinner.hide();
          this.spinner.hide();
          if (res.status) {
            this.commonApiService.openSnackbar(
              'Password reset link sent to your email.'
            );
            this.toggleForm(); // Switch back to login form after success
          } else {
            this.commonApiService.openSnackbar(
              'Email is not registered. Enter a valid email!'
            );
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
    } else {
      SharedValidators.markAllAsTouched(this.forgotPasswordForm);
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
